var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowEggLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 16.0002C24 20.1303 21.1146 22.6668 18.5 22.6668C16.7808 22.6668 13.5178 21.7747 10.6343 20.0893C9.23951 19.274 8.15473 18.3978 7.46267 17.5758C6.76834 16.7512 6.66669 16.2293 6.66669 16.0002C6.66669 15.7711 6.76834 15.2492 7.46267 14.4245C8.15473 13.6026 9.23951 12.7263 10.6343 11.9111C13.5178 10.2257 16.7808 9.3335 18.5 9.3335C21.1146 9.3335 24 11.8701 24 16.0002ZM28 16.0002C28 21.8912 23.7467 26.6668 18.5 26.6668C13.2533 26.6668 2.66669 21.8912 2.66669 16.0002C2.66669 10.1091 13.2533 5.3335 18.5 5.3335C23.7467 5.3335 28 10.1091 28 16.0002Z",
    fill: "#3360AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEggLeft);
export default __webpack_public_path__ + "static/media/arrow-egg-left.c9feef1d0986a0579cc84ce1953ae8d4.svg";
export { ForwardRef as ReactComponent };